import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'

//import Grilla from './grilla'
import {LoadingComponent} from 'recupero-comunes'

import { configuracionFormAction35, obtenerIngresoGrilla } from '../../store/actions/ingreso-recobro-action'
import Formulario from './formulario'
import Grilla from './Grilla'


const IngresoRecobro = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso , tipoGestion, ambitoGestion}) => {
    const [loading,setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
   const dispatch=useDispatch()
    
    useEffect(() => {     

        dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
      useEffect(() => {
        if(llaves){  
            setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 35
        })).toString('base64')
        dispatch(configuracionFormAction35(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idCaso": llaves && llaves['idCaso'],
                "idImplicado": llaves && llaves['idImplicado']
            })).toString('base64')
            dispatch(obtenerIngresoGrilla(query))
        })
       
        .then(()=>{
            setLoading(false)
        })
    
    }
    }, [dispatch,llaves])
    return (
        <>
        <LoadingComponent show={loading}/>
            <Formulario handleClose={handleClose}/>
                <Grilla/>
        </>
    )
}

export default IngresoRecobro
